// extracted by mini-css-extract-plugin
module.exports = {"m1efqszy":"m1efqszy"};